import React, { useState } from 'react';
import { Editor } from '@tinymce/tinymce-react';
import { Link } from "react-router-dom";
import Header from "../Header";
import Footer from "../Footer";
import config from "../common/Config";
import Swal from "sweetalert2";

const EmailTemplateEditor = () => {
  const [templateName, setTemplateName] = useState('');
  const [templateSubject, setTemplateSubject] = useState('');
  const [templateContent, setTemplateContent] = useState('');
  const [message, setMessage] = useState('');
  const [isUpdate, setIsUpdate] = useState(false);
  const [status, setStatus] = useState('1'); // Default to Active
  const [send_email, setSendEmail] = useState('');
  const accessToken = localStorage.getItem("accessToken");
  const userId = localStorage.getItem("userId");
  // Handle editor change
  const handleEditorChange = (content) => {
    setTemplateContent(content);
  };

  // Handle template selection and fetch data
  const handleTemplateChange = async (e) => {
    const selectedName = e.target.value;
    setTemplateName(selectedName);

    if (selectedName) {
      const response = await fetch(`${config.API_URL}/email_templates_get_by_name`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Bearer ${accessToken}`,
        },
        body: JSON.stringify({ name: selectedName }),
      });
      if (response.ok) {
        const data = await response.json();
        setTemplateSubject(data.subject || '');
        setTemplateContent(data.content || '');
        setStatus(data.status !== undefined ? String(data.status) : '1');
        setIsUpdate(!!data.subject);
        setSendEmail(!!data.send_email ? data.send_email : ''); // Set send_email if subject exists
      } else {
        setTemplateSubject('');
        setTemplateContent('');
        setStatus('1');
        setSendEmail(''); // Reset send_email if no data
        setIsUpdate(false);
      }
    } else {
      setTemplateSubject('');
      setTemplateContent('');
      setStatus('1');
      setSendEmail(''); // Reset send_email if no data
      setIsUpdate(false);
    }
  };

  // Insert shortcode at cursor
  const insertShortcode = (shortcode) => {
    const editor = window.tinymce.activeEditor;
    if (editor) {
      const selection = editor.selection;
      selection.setContent(shortcode + '\n');
    }
  };

  // Handle form submit (create or update)
  const handleSubmit = async (e) => {
    e.preventDefault();
    const url = isUpdate
      ? `${config.API_URL}/email_templates_update`
      : `${config.API_URL}/email_templates_store`;

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'authorization': `Bearer ${accessToken}`,
      },
      body: JSON.stringify({
        name: templateName,
        subject: templateSubject,
        content: templateContent,
        status: status,
        send_email: send_email,
        user_id: userId,
      }),
    });

   if (response.ok) {
  //setMessage(isUpdate ? 'Template updated successfully!' : 'Template saved successfully!');
  Swal.fire({
    title: "Success",
    text: isUpdate ? "Template updated successfully!" : "Template saved successfully!",
    icon: "success",
    timer: 1500,
    showConfirmButton: false,
  });
} else {
  //setMessage('Failed to save template.');
  Swal.fire({
    title: "Error",
    text: "Failed to save template.",
    icon: "error",
    timer: 1500,
    showConfirmButton: false,
  });
}
  };

  return (
    <>
      <Header />
      <div className="breadcrumbs">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-lg-12 col-sm-12">
              <Link to="/Dashboard"><i className="fa fa-home"></i></Link>
              <Link to="/sales/newsales">Email</Link>
              <Link to="/sales/newsales">Email Template</Link>
            </div>
          </div>
        </div>
      </div>

      <div className="main-container">
        <div className="container-fluid">
          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-lg-6">
                <div className="col-md-12">
                  <label>Template Name:</label>
                  <select name="templateName" id="templateName" value={templateName} onChange={handleTemplateChange}
                    required className="form-control" >
                    <option value="">Select a Template</option>
                    <option value="Place Order"> Order Confirmation</option>
                    <option value="Order Accepted">Order Accepted</option>
                    <option value="Send Tax Invoice">Send Tax Invoice</option>
                    <option value="Amount Due">Amount Due</option>
                    <option value="Reminder 1 - over due amount">Reminder 1 - Overdue Amount</option>
                    <option value="Reminder 2 - overdue amount">Reminder 2 - Overdue Amount</option>
                    <option value="Reminder 3 - overdue amount">Reminder 3 - Overdue Amount</option>
                    <option value="New account request">New Account Request</option>
                    <option value="Account opened">Account Opened</option>
                  </select>
                </div>
                <div className="col-md-12">
              
                  <label style={{ marginTop: '10px' }}>Template Subject:</label>
                  <input type="text" className="form-control" value={templateSubject} onChange={e => setTemplateSubject(e.target.value)}
                    style={{ width: '100%' }} name="subject"id="subject"
                  />
                </div>
                <label style={{ marginTop: '10px' }}>Template Body:</label>
                 <Editor value={templateContent}
                    init={{
                      height: 300,
                      menubar: false,
                      plugins: ['link', 'table', 'code'],
                      branding: false,
                      toolbar: 'undo redo | formatselect | bold italic | alignleft aligncenter alignright | link image',
                      content_style: "body { line-height: 0.5; }", // <-- Double line spacing
                    }}
                    onEditorChange={handleEditorChange}
                  />
                
                <div style={{ margin: '10px 0' }}>
                  <button type="button" onClick={() => insertShortcode('{Customer_name}')}> Customer Name</button>
                  <button type="button" onClick={() => insertShortcode('{Company_name}')}> Company Name</button>
                 {(templateName !== "New account request" && templateName !== "Account opened" && templateName !== "Amount Due" && templateName !== "Reminder 1 - over due amount" && templateName !== "Reminder 2 - overdue amount" && templateName !== "Reminder 3 - overdue amount") && (
               
                <>
                
                  {/* <button type="button" onClick={() => insertShortcode('{Phone_no}')}> Phone No</button> */}
                  <button type="button" onClick={() => insertShortcode('{Order_no}')}> Order No</button>
                  <button type="button" onClick={() => insertShortcode('{Order_date}')}> Order Date</button>
                  <button type="button" onClick={() => insertShortcode('{Invoice_date}')}> Invoice Date</button>
                  <button type="button" onClick={() => insertShortcode('{Order_amount}')}> Order Amount</button>
                 </>
              )}
                 {(templateName === "New account request" || templateName === "Account opened") && (
                <>
                  <button type="button" onClick={() => insertShortcode('{Site_link}')}> Web Site Link</button>
                  <button type="button" onClick={() => insertShortcode('{User_name}')}> User Name</button>
                  <button type="button" onClick={() => insertShortcode('{Password}')}> Password</button>
                </>
              )}
               {(templateName === "Amount Due" || templateName === "Reminder 1 - over due amount" || templateName === "Reminder 2 - overdue amount" || templateName === "Reminder 3 - overdue amount") && (
                <>
                  <button type="button" onClick={() => insertShortcode('{Amount Due}')}> Amount Due</button>
                  <button type="button" onClick={() => insertShortcode('{Due_day}')}> Due Day</button>
                </>
              )}
                </div>
                 <div className="row" >
                <div className="col-md-4" >
                  
                  <label>Status:</label>
                  <select className="form-control"  value={status} onChange={e => setStatus(e.target.value)} name="status">
                    <option value="1">Active</option>
                    <option value="0">Inactive</option>
                  </select>
                </div>
               <div className="col-md-8" >                  
                <label> Send Email For</label>
                <select className="form-control" value={send_email} onChange={e => setSendEmail(e.target.value)}
                  name="send_email"
                >
                  <option value="customer">Customer Only</option>
                  <option value="company">Company Only</option>
                  <option value="both">Both</option>
                </select>
              </div>
                </div>
                <button type="submit" className="btn btn-primary" style={{ marginTop: '15px' }}>
                  {isUpdate ? 'Update Template' : 'Save Template'}
                </button>
                {message && <div style={{ marginTop: '10px' }}>{message}</div>}

              </div>
              <div style={{ marginTop: '60px' }}>{message}</div>
              {/* <div className="col-lg-6">
                <h3>Live Preview:</h3>
                <div
                  style={{ border: '1px solid #ccc', padding: '10px', minHeight: '300px' }}
                  dangerouslySetInnerHTML={{ __html: templateContent }}
                />
              </div> */}
            </div>
          </form>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default EmailTemplateEditor;